import React from 'react';
import { colors } from '@insurancemenu/imenu-components-lib';
import { BriefcaseMedical, ShieldHeart } from '@insurancemenu/imenu-components-lib/dist/icons';
import {
  AnswerExplanationStyled,
  AnswerOptionStyled,
  AnswerTextSectionStyled,
  AnswerTextStyled,
  IconWrapperStyled,
} from './styles';

export type MedicalHistoryAnswer = 'yes' | 'no';

interface OptionContent {
  label: string;
  description: string;
  icon: React.ReactNode;
  accentColor: string;
}

const MEDICAL_HISTORY_OPTION_MAP: Record<MedicalHistoryAnswer, OptionContent> = {
  yes: {
    label: 'Yes, I have had a medical condition, surgery, or regular prescription in the past 5 years',
    description: 'I will provide details about the condition(s) in the next step',
    icon: <BriefcaseMedical width="3rem" height="3rem" color={colors.yellow[600]} />,
    accentColor: colors.yellow[100],
  },
  no: {
    label: 'No, I (or any dependents) have not had any',
    description: 'I can continue without providing additional health information',
    icon: <ShieldHeart width="3rem" height="3rem" color={colors.green[600]} />,
    accentColor: colors.green[100],
  },
};

const AnswerOption: React.FC<{ answer: MedicalHistoryAnswer }> = ({ answer }) => {
  const { label, description, icon, accentColor } = MEDICAL_HISTORY_OPTION_MAP[answer];

  return (
    <AnswerOptionStyled>
      <IconWrapperStyled $accentColor={accentColor}>{icon}</IconWrapperStyled>
      <AnswerTextSectionStyled>
        <AnswerTextStyled>{label}</AnswerTextStyled>
        <AnswerExplanationStyled>{description}</AnswerExplanationStyled>
      </AnswerTextSectionStyled>
    </AnswerOptionStyled>
  );
};

export default AnswerOption;
